import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useGeo } from './GeoContext';

// Country code → currency code mapping (190+ countries)
const COUNTRY_CURRENCY = {
  AF:'AFN',AL:'ALL',DZ:'DZD',AD:'EUR',AO:'AOA',AG:'XCD',AR:'ARS',AM:'AMD',AU:'AUD',
  AT:'EUR',AZ:'AZN',BS:'BSD',BH:'BHD',BD:'BDT',BB:'BBD',BY:'BYN',BE:'EUR',BZ:'BZD',
  BJ:'XOF',BT:'BTN',BO:'BOB',BA:'BAM',BW:'BWP',BR:'BRL',BN:'BND',BG:'BGN',BF:'XOF',
  BI:'BIF',KH:'KHR',CM:'XAF',CA:'CAD',CV:'CVE',CF:'XAF',TD:'XAF',CL:'CLP',CN:'CNY',
  CO:'COP',KM:'KMF',CG:'XAF',CD:'CDF',CR:'CRC',CI:'XOF',HR:'EUR',CU:'CUP',CY:'EUR',
  CZ:'CZK',DK:'DKK',DJ:'DJF',DM:'XCD',DO:'DOP',EC:'USD',EG:'EGP',SV:'USD',GQ:'XAF',
  ER:'ERN',EE:'EUR',SZ:'SZL',ET:'ETB',FJ:'FJD',FI:'EUR',FR:'EUR',GA:'XAF',GM:'GMD',
  GE:'GEL',DE:'EUR',GH:'GHS',GR:'EUR',GD:'XCD',GT:'GTQ',GN:'GNF',GW:'XOF',GY:'GYD',
  HT:'HTG',HN:'HNL',HU:'HUF',IS:'ISK',IN:'INR',ID:'IDR',IR:'IRR',IQ:'IQD',IE:'EUR',
  IL:'ILS',IT:'EUR',JM:'JMD',JP:'JPY',JO:'JOD',KZ:'KZT',KE:'KES',KI:'AUD',KW:'KWD',
  KG:'KGS',LA:'LAK',LV:'EUR',LB:'LBP',LS:'LSL',LR:'LRD',LY:'LYD',LI:'CHF',LT:'EUR',
  LU:'EUR',MG:'MGA',MW:'MWK',MY:'MYR',MV:'MVR',ML:'XOF',MT:'EUR',MH:'USD',MR:'MRU',
  MU:'MUR',MX:'MXN',FM:'USD',MD:'MDL',MC:'EUR',MN:'MNT',ME:'EUR',MA:'MAD',MZ:'MZN',
  MM:'MMK',NA:'NAD',NR:'AUD',NP:'NPR',NL:'EUR',NZ:'NZD',NI:'NIO',NE:'XOF',NG:'NGN',
  KP:'KPW',MK:'MKD',NO:'NOK',OM:'OMR',PK:'PKR',PW:'USD',PA:'PAB',PG:'PGK',PY:'PYG',
  PE:'PEN',PH:'PHP',PL:'PLN',PT:'EUR',QA:'QAR',RO:'RON',RU:'RUB',RW:'RWF',KN:'XCD',
  LC:'XCD',VC:'XCD',WS:'WST',SM:'EUR',ST:'STN',SA:'SAR',SN:'XOF',RS:'RSD',SC:'SCR',
  SL:'SLL',SG:'SGD',SK:'EUR',SI:'EUR',SB:'SBD',SO:'SOS',ZA:'ZAR',KR:'KRW',SS:'SSP',
  ES:'EUR',LK:'LKR',SD:'SDG',SR:'SRD',SE:'SEK',CH:'CHF',SY:'SYP',TW:'TWD',TJ:'TJS',
  TZ:'TZS',TH:'THB',TL:'USD',TG:'XOF',TO:'TOP',TT:'TTD',TN:'TND',TR:'TRY',TM:'TMT',
  TV:'AUD',UG:'UGX',UA:'UAH',AE:'AED',GB:'GBP',US:'USD',UY:'UYU',UZ:'UZS',VU:'VUV',
  VE:'VES',VN:'VND',YE:'YER',ZM:'ZMW',ZW:'ZWL',
};

// Currency code → symbol mapping
const CURRENCY_SYMBOLS = {
  AUD:'AU$',USD:'$',EUR:'€',GBP:'£',JPY:'¥',CNY:'¥',INR:'₹',KRW:'₩',BRL:'R$',
  SAR:'﷼',PGK:'K',NGN:'₦',KES:'KSh',ZAR:'R',GHS:'₵',EGP:'E£',PKR:'₨',BDT:'৳',
  THB:'฿',VND:'₫',PHP:'₱',IDR:'Rp',MYR:'RM',SGD:'S$',HKD:'HK$',TWD:'NT$',TRY:'₺',
  RUB:'₽',PLN:'zł',CZK:'Kč',SEK:'kr',NOK:'kr',DKK:'kr',CHF:'CHF',NZD:'NZ$',CAD:'C$',
  MXN:'MX$',ARS:'AR$',COP:'CO$',PEN:'S/',CLP:'CL$',FJD:'FJ$',XOF:'CFA',XAF:'FCFA',
  AED:'د.إ',QAR:'QR',KWD:'KD',BHD:'BD',OMR:'OMR',JOD:'JD',ILS:'₪',MAD:'MAD',
  TZS:'TSh',UGX:'USh',RWF:'RF',ETB:'Br',MZN:'MT',ZMW:'ZK',MWK:'MK',BWP:'P',
  NAD:'N$',LSL:'L',SZL:'E',MUR:'₨',SCR:'₨',MMK:'K',KHR:'៛',LAK:'₭',MNT:'₮',
  GEL:'₾',AMD:'֏',AZN:'₼',UAH:'₴',MDL:'L',BAM:'KM',RSD:'din',MKD:'ден',
  ALL:'L',HUF:'Ft',RON:'lei',BGN:'лв',HRK:'kn',ISK:'kr',
  LKR:'Rs',NPR:'Rs',MVR:'Rf',AFN:'؋',IRR:'﷼',IQD:'ع.د',LBP:'ل.ل',SYP:'£S',
  YER:'﷼',SDG:'ج.س',LYD:'LD',TND:'DT',DZD:'د.ج',JMD:'J$',TTD:'TT$',GYD:'G$',
  BBD:'Bds$',XCD:'EC$',BSD:'B$',BZD:'BZ$',HTG:'G',HNL:'L',NIO:'C$',CRC:'₡',
  PAB:'B/.',DOP:'RD$',CUP:'$MN',GTQ:'Q',PYG:'₲',UYU:'$U',BOB:'Bs.',VES:'Bs.S',
  SRD:'SRD',CDF:'FC',GNF:'FG',BIF:'FBu',KMF:'CF',DJF:'Fdj',MGA:'Ar',MRU:'UM',
  CVE:'$',STN:'Db',SBD:'SI$',TOP:'T$',VUV:'VT',WST:'WS$',SLL:'Le',GMD:'D',
  LRD:'L$',SSP:'SS£',ZWL:'Z$',ERN:'Nkf',TMT:'T',KGS:'сом',TJS:'SM',UZS:'сўм',
  KZT:'₸',BYN:'Br',AOA:'Kz',SOS:'Sh',
};

const STORAGE_KEY = 'gopiko_currency';
const BASE = 'AUD';

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [rates, setRates] = useState(null);
  const [userCurrency, setUserCurrency] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || null;
  });
  const [isManuallySelected, setIsManuallySelected] = useState(() => {
    return !!localStorage.getItem(STORAGE_KEY);
  });
  const [detectedCountry, setDetectedCountry] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userCountry: geoSelectedCountry } = useGeo();

  // When user switches country via CountrySwitcher, update currency to match
  useEffect(() => {
    if (!geoSelectedCountry || isManuallySelected) return;
    const NAME_TO_CODE_QUICK = {
      'australia':'AU','united states':'US','united kingdom':'GB','canada':'CA',
      'new zealand':'NZ','india':'IN','pakistan':'PK','philippines':'PH',
      'papua new guinea':'PG','fiji':'FJ','samoa':'WS','tonga':'TO','vanuatu':'VU',
      'solomon islands':'SB','singapore':'SG','malaysia':'MY','indonesia':'ID',
      'nigeria':'NG','south africa':'ZA','kenya':'KE','ghana':'GH','tanzania':'TZ',
      'uganda':'UG','zimbabwe':'ZW','zambia':'ZM','egypt':'EG','morocco':'MA',
      'japan':'JP','china':'CN','south korea':'KR','thailand':'TH','vietnam':'VN',
      'bangladesh':'BD','sri lanka':'LK','nepal':'NP','myanmar':'MM',
      'saudi arabia':'SA','uae':'AE','united arab emirates':'AE','qatar':'QA',
      'germany':'DE','france':'FR','spain':'ES','italy':'IT','brazil':'BR','mexico':'MX',
      'argentina':'AR','chile':'CL','colombia':'CO','peru':'PE','turkey':'TR','russia':'RU',
      'sweden':'SE','norway':'NO','denmark':'DK','switzerland':'CH','ireland':'IE',
      'jamaica':'JM','trinidad and tobago':'TT','bahamas':'BS','barbados':'BB',
    };
    const code = NAME_TO_CODE_QUICK[geoSelectedCountry.toLowerCase()];
    if (code && COUNTRY_CURRENCY[code]) {
      setUserCurrency(COUNTRY_CURRENCY[code]);
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [geoSelectedCountry, isManuallySelected]);

  // Detect country via geo-detect API (IP-based), falling back to browser locale
  useEffect(() => {
    const detectFromBrowser = () => {
      try {
        const langs = navigator.languages || [navigator.language];
        for (const lang of langs) {
          const parts = lang.split('-');
          if (parts.length >= 2) {
            const country = parts[parts.length - 1].toUpperCase();
            if (COUNTRY_CURRENCY[country]) return country;
          }
        }
      } catch { /* */ }
      return null;
    };

    const detectCountry = async () => {
      // 1. Try IP-based geo detection (most accurate for actual location)
      try {
        const geo = await api.request('/geo/detect');
        if (geo?.country_code && COUNTRY_CURRENCY[geo.country_code.toUpperCase()]) {
          setDetectedCountry(geo.country_code.toUpperCase());
          return;
        }
      } catch { /* geo API failed, fall through */ }

      // 2. Fallback to browser locale
      const browserCountry = detectFromBrowser();
      if (browserCountry) {
        setDetectedCountry(browserCountry);
      }
    };

    detectCountry();
  }, []);

  // Set currency based on detected country (only if user hasn't manually selected AND no country switcher override)
  useEffect(() => {
    if (geoSelectedCountry) return; // Country switcher takes priority over IP detection
    if (!localStorage.getItem(STORAGE_KEY) && detectedCountry && COUNTRY_CURRENCY[detectedCountry]) {
      setUserCurrency(COUNTRY_CURRENCY[detectedCountry]);
    } else if (!localStorage.getItem(STORAGE_KEY) && !detectedCountry) {
      setUserCurrency(BASE);
    }
  }, [detectedCountry, geoSelectedCountry]);

  // Fetch exchange rates
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const data = await api.getExchangeRates();
        if (data.rates) setRates(data.rates);
      } catch (e) {
        console.warn('Failed to fetch exchange rates:', e);
      }
      setLoading(false);
    };
    fetchRates();
  }, []);

  const setCurrency = useCallback((code) => {
    if (code === 'AUTO') {
      setIsManuallySelected(false);
      localStorage.removeItem(STORAGE_KEY);
      if (detectedCountry && COUNTRY_CURRENCY[detectedCountry]) {
        setUserCurrency(COUNTRY_CURRENCY[detectedCountry]);
      } else {
        setUserCurrency(BASE);
      }
      return;
    }
    setUserCurrency(code);
    setIsManuallySelected(true);
    localStorage.setItem(STORAGE_KEY, code);
  }, [detectedCountry]);

  // Convert amount from any source currency to user's currency
  const convert = useCallback((amount, fromCurrency = BASE) => {
    if (!rates || !userCurrency) return amount;
    const from = fromCurrency || BASE;
    if (from === userCurrency) return amount;
    // Convert: source → AUD → target
    const fromRate = rates[from] || 1;
    const toRate = rates[userCurrency] || 1;
    return amount * (toRate / fromRate);
  }, [rates, userCurrency]);

  // Format price — shows listing's original currency by default,
  // only converts when user has manually picked a currency via the switcher.
  // opts.from = the listing's stored currency (e.g. "PGK", "USD")
  // When from is provided and no manual selection → display in `from` currency (no conversion)
  // When from is provided and manual selection → convert to manually selected currency
  // When from is NOT provided → platform price, display in userCurrency
  const formatLocal = useCallback((amount, opts = {}) => {
    if (amount === null || amount === undefined || isNaN(amount)) return '';
    const { compact = false, showOriginal = false, from } = opts;

    let displayCurrency, displayAmount;
    if (from && !isManuallySelected) {
      displayCurrency = from;
      displayAmount = amount;
    } else if (from && isManuallySelected) {
      displayCurrency = userCurrency || BASE;
      displayAmount = convert(amount, from);
    } else {
      displayCurrency = userCurrency || BASE;
      displayAmount = amount;
    }

    const sym = CURRENCY_SYMBOLS[displayCurrency] || displayCurrency + ' ';

    try {
      const noDecimals = ['JPY','KRW','VND','CLP','PYG','UGX','KMF','GNF','BIF','VUV','RWF','DJF','XOF','XAF','MGA'];
      const formatter = new Intl.NumberFormat('en', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        notation: compact ? 'compact' : 'standard',
      });
      const formatted = `${sym}${formatter.format(displayAmount)}`;
      if (showOriginal && from && displayCurrency !== from) {
        const fromSym = CURRENCY_SYMBOLS[from] || from + ' ';
        return `${formatted} (${fromSym}${amount.toLocaleString()})`;
      }
      return formatted;
    } catch {
      return `${sym}${Math.round(displayAmount).toLocaleString()}`;
    }
  }, [convert, userCurrency, isManuallySelected]);

  // Reverse lookup: country name → currency code
  const getCurrencyForCountry = useCallback((countryName) => {
    if (!countryName) return BASE;
    // Try direct country code first
    const upper = countryName.toUpperCase();
    if (COUNTRY_CURRENCY[upper]) return COUNTRY_CURRENCY[upper];
    // Try matching country name to code via known names
    const NAME_TO_CODE = {
      'australia':'AU','united states':'US','usa':'US','united kingdom':'GB','uk':'GB',
      'canada':'CA','new zealand':'NZ','india':'IN','china':'CN','japan':'JP',
      'south korea':'KR','germany':'DE','france':'FR','spain':'ES','italy':'IT',
      'brazil':'BR','mexico':'MX','nigeria':'NG','south africa':'ZA','kenya':'KE',
      'ghana':'GH','egypt':'EG','pakistan':'PK','bangladesh':'BD','sri lanka':'LK',
      'thailand':'TH','vietnam':'VN','philippines':'PH','indonesia':'ID','malaysia':'MY',
      'singapore':'SG','hong kong':'HK','taiwan':'TW','turkey':'TR','russia':'RU',
      'poland':'PL','czech republic':'CZ','sweden':'SE','norway':'NO','denmark':'DK',
      'switzerland':'CH','netherlands':'NL','belgium':'BE','austria':'AT','ireland':'IE',
      'portugal':'PT','greece':'GR','saudi arabia':'SA','uae':'AE','united arab emirates':'AE',
      'qatar':'QA','kuwait':'KW','bahrain':'BH','oman':'OM','jordan':'JO','israel':'IL',
      'papua new guinea':'PG','fiji':'FJ','samoa':'WS','tonga':'TO','vanuatu':'VU',
      'solomon islands':'SB','argentina':'AR','chile':'CL','colombia':'CO','peru':'PE',
      'ecuador':'EC','venezuela':'VE','bolivia':'BO','paraguay':'PY','uruguay':'UY',
      'jamaica':'JM','trinidad and tobago':'TT','bahamas':'BS','barbados':'BB',
      'dominican republic':'DO','haiti':'HT','guatemala':'GT','honduras':'HN',
      'el salvador':'SV','nicaragua':'NI','costa rica':'CR','panama':'PA','cuba':'CU',
      'morocco':'MA','algeria':'DZ','tunisia':'TN','libya':'LY','sudan':'SD',
      'ethiopia':'ET','tanzania':'TZ','uganda':'UG','rwanda':'RW','mozambique':'MZ',
      'zambia':'ZM','zimbabwe':'ZW','botswana':'BW','namibia':'NA','malawi':'MW',
      'madagascar':'MG','senegal':'SN','cameroon':'CM','ivory coast':'CI',
      'congo':'CG','congo (drc)':'CD','angola':'AO','somalia':'SO','south sudan':'SS',
      'nepal':'NP','myanmar':'MM','cambodia':'KH','laos':'LA','mongolia':'MN',
      'kazakhstan':'KZ','uzbekistan':'UZ','afghanistan':'AF','iran':'IR','iraq':'IQ',
      'lebanon':'LB','syria':'SY','yemen':'YE','ukraine':'UA','romania':'RO',
      'hungary':'HU','bulgaria':'BG','serbia':'RS','croatia':'HR','slovakia':'SK',
      'slovenia':'SI','lithuania':'LT','latvia':'LV','estonia':'EE','malta':'MT',
      'cyprus':'CY','iceland':'IS','luxembourg':'LU','brunei':'BN','maldives':'MV',
      'mauritius':'MU','seychelles':'SC',
    };
    const code = NAME_TO_CODE[countryName.toLowerCase()];
    if (code && COUNTRY_CURRENCY[code]) return COUNTRY_CURRENCY[code];
    return BASE;
  }, []);

  // Format platform prices (always AUD base) in the user's local currency.
  // Unlike formatLocal, this ALWAYS converts regardless of manual selection.
  const formatPlatform = useCallback((amount, opts = {}) => {
    if (amount === null || amount === undefined || isNaN(amount)) return '';
    if (amount === 0) return 'Free';
    const { compact = false, suffix = '' } = opts;
    const target = userCurrency || BASE;
    const converted = convert(amount, BASE);
    const sym = CURRENCY_SYMBOLS[target] || target + ' ';
    try {
      const formatter = new Intl.NumberFormat('en', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        notation: compact ? 'compact' : 'standard',
      });
      return `${sym}${formatter.format(converted)}${suffix}`;
    } catch {
      return `${sym}${Math.round(converted).toLocaleString()}${suffix}`;
    }
  }, [convert, userCurrency]);

  // Convert between any two currencies (not locked to userCurrency)
  const convertTo = useCallback((amount, fromCurrency, toCurrency) => {
    if (!rates || !toCurrency || !fromCurrency) return amount;
    if (fromCurrency === toCurrency) return amount;
    const fromRate = rates[fromCurrency] || 1;
    const toRate = rates[toCurrency] || 1;
    return amount * (toRate / fromRate);
  }, [rates]);

  const value = {
    userCurrency: userCurrency || BASE,
    isManuallySelected,
    detectedCountry,
    rates,
    loading,
    setCurrency,
    convert,
    convertTo,
    formatLocal,
    formatPlatform,
    getCurrencyForCountry,
    baseCurrency: BASE,
    currencyList: Object.entries(CURRENCY_SYMBOLS).map(([code, symbol]) => ({ code, symbol })).sort((a, b) => a.code.localeCompare(b.code)),
    getSymbol: (code) => CURRENCY_SYMBOLS[code] || code,
  };

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) return {
    userCurrency: BASE, formatLocal: (p) => `AU$${p?.toLocaleString() || '0'}`,
    formatPlatform: (p) => p === 0 ? 'Free' : `AU$${p?.toLocaleString() || '0'}`,
    convert: (p) => p, setCurrency: () => {}, loading: false, baseCurrency: BASE,
    currencyList: [], getSymbol: () => 'AU$',
  };
  return ctx;
}

export default CurrencyContext;
